import { stats } from "../data";
import { Card, Section, tintTextClass } from "../shared";

/**
 * Three centered stat cards showcasing platform scale.
 *
 * @returns {import("react").ReactElement}
 */
export function Stats() {
  return (
    <Section className="bg-white">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
        {stats.map((stat) => (
          <Card key={stat.label} padding="lg" className="text-center">
            <div className="font-display text-ink text-[clamp(44px,6vw,60px)] leading-none font-semibold tracking-tight">
              {stat.num}
              <span className={tintTextClass[stat.accentColor]}>{stat.accent}</span>
            </div>
            <div className="text-muted mt-4 text-sm font-medium tracking-[0.1em] uppercase">
              {stat.label}
            </div>
          </Card>
        ))}
      </div>
    </Section>
  );
}
